/* Speed audit F-14 (14 Sep 2026)
   updateAspectRatios() used to set each slide's padding-top with JavaScript after the page
   loaded. Because the banner images are absolutely positioned they contribute no height, so
   every banner section was zero pixels tall until this ran - then all of them inflated at
   once, which was the bulk of a 0.99 Cumulative Layout Shift on the homepage.
   The same ratios now come from CSS variables written inline by sections/slider-hero.liquid,
   so heights are correct from the first paint and this script no longer touches layout.
   Button handlers are guarded because most Slider Hero sections hold a single slide. */
class RkSliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.rk-slider');
    this.slides = this.querySelectorAll('.rk-slider__slide');
    this.prevButton = this.querySelector('.rk-slider-button--prev');
    this.nextButton = this.querySelector('.rk-slider-button--next');
    this.currentSlide = 0;

    if (this.slides.length < 2) {
      if (this.prevButton) this.prevButton.hidden = true;
      if (this.nextButton) this.nextButton.hidden = true;
      return;
    }

    if (this.prevButton) this.prevButton.addEventListener('click', () => this.showPrevSlide());
    if (this.nextButton) this.nextButton.addEventListener('click', () => this.showNextSlide());
  }

  showPrevSlide() {
    this.currentSlide = this.currentSlide > 0 ? this.currentSlide - 1 : this.slides.length - 1;
    this.updateSlider();
  }

  showNextSlide() {
    this.currentSlide = this.currentSlide < this.slides.length - 1 ? this.currentSlide + 1 : 0;
    this.updateSlider();
  }

  updateSlider() {
    if (this.slider) this.slider.style.transform = `translateX(-${this.currentSlide * 100}%)`;
  }
}

if (!customElements.get('rk-slider-component')) {
  customElements.define('rk-slider-component', RkSliderComponent);
}
